import { Component } from 'react';
import propTypes from 'prop-types';
import {currentUserGroup} from '../../../utils/tokenUtils';

class UserGroupGuard extends Component {
  render() {
    const {type, children} = this.props;
    const group = currentUserGroup();

    if (!group) {
      return null;
    }

    const match = (Array.isArray(type) && type.find(t => group === t)) || type === group;

    return (
      <div>
        {match && children}
      </div>
    );
  }
}

UserGroupGuard.propTypes = {
  children: propTypes.node,
  type: propTypes.oneOfType([propTypes.arrayOf(propTypes.string), propTypes.string]),
};

export default UserGroupGuard;
